package music.limasoul.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository

class DeleteEventUseCase(
    private val eventRepository: EventRepository,
) {

    suspend operator fun invoke(eventId: Long) {
        eventRepository.delete(eventId)
    }
}